import React from 'react';

import { ModalContainer } from 'components/guardedModal/ModalContainer';
import { DeleteParticipantModalContentContainer } from './DeleteParticipantModalContent';
import { SimpleModalId } from 'constants/modalId';

export const DeleteParticipantModal = () => (
  <ModalContainer id={SimpleModalId.DeleteParticipant}>
    <DeleteParticipantModalContentContainer />
  </ModalContainer>
);
